import { PlanDefinitionAction } from "@medplum/fhirtypes";

import { format } from "date-fns";

import { getCodeableConceptCode } from "@/utils/medplum";

export function formatLabOrdersDisplay(actions?: PlanDefinitionAction[]): string[] {
  const firstThreeLabs = actions
    ?.slice(0, 3)
    .map((action) => getCodeableConceptCode(action.code?.[0]))
    .filter(Boolean)
    .join(", ");
  const remainingLabsCount = actions?.length ? actions.length - 3 : 0;

  return [firstThreeLabs ?? "", remainingLabsCount > 0 ? `+${remainingLabsCount}` : ""];
}

export function formatLastUpdatedDisplay(lastUpdated?: string): string {
  return lastUpdated ? format(new Date(lastUpdated), " MMMM d, yyyy 'at' h:mm a") : "Never";
}
